import Vue from 'vue';
// import SpecialLearn from './SpecialLearn';
import SpecialLearnList from './SpecialLearnList';
// import Correct from './Correct'
// const ROUTER = { "": SpecialLearn, "#correctresult": Correct};

new Vue({
    data: {
        learnRecordData:{},
        curHash:window.location.hash,
    },
    render: function (h) {
        return h(SpecialLearnList)
    },
}).$mount(process.env.NODE_ENV === 'development' ? "#app" : '#zx_learn_3' );
